/** @format */
import { largeTablet } from '@mpb-com/feather/helpers/media-queries';
import styled, { css } from 'styled-components';

export const StyledContentAccordionGroup = styled('div')`
    display: grid;
    gap: 16px;
    grid-template-columns: 1fr 1fr;

    ${largeTablet(css`
        grid-template-columns: 1fr;
    `)}
`;
